module.exports = __webpack_public_path__ + "static/media/logoQualiReparDesktop.2dd8c31d.png";